import { timestampObjectToDate } from "api/repositories/FirebaseRepository/FirebaseUtils";
import { shortMonths } from "i18nLang";

export function formatPeriodDate(
  initialDate: Date | { _seconds: number; _nanoseconds: number },
  finalDate: Date | { _seconds: number; _nanoseconds: number }
): string {
  if (!(initialDate instanceof Date)) {
    initialDate = timestampObjectToDate(initialDate);
  }

  if (!(finalDate instanceof Date)) {
    finalDate = timestampObjectToDate(finalDate);
  }

  return formatDate(initialDate) + " - " + formatDate(finalDate);
}

export function formatDate(date: Date): string {
  const months = shortMonths();
  return (
    date.getDate() + " " + months[date.getMonth()] + " " + date.getFullYear()
  );
}
